import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=f5aa7668&lang=pug&"
import script from "./VehicleForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleForm.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleForm.vue?vue&type=style&index=0&id=f5aa7668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports